import {getTemplateLanguage} from './language'

var langmap={}

export async function initTemplateTranslate(){
	var lang=getTemplateLanguage()
	langmap[lang]=await import(`@/components/i18n/locals-view/${lang}.json`)
}

export default function(key,...args){
	var lang=getTemplateLanguage()
	var word=langmap[lang][key]
	if(!word){
		console.warn(`can't translate "${key}"`)
		return key
	}
	for(let i=0;i<args.length;i++){
		word=word.replace('$'+i,'😉'+args[i])
	}
	word=word.replace(/😉/g,'')
	return word
}